module.exports = __webpack_public_path__ + "static/18-f7b0953ba744dc4f4a120c7747a9c535.png";